'use client';

import React, { useState, useEffect } from 'react';
import Link from 'next/link';

const CookieBanner = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie-consent');
    if (consent === null) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookie-consent', 'true');
    setShowBanner(false);
    window.gtag('consent', 'update', {
      'ad_storage': 'granted',
      'analytics_storage': 'granted'
    });
  };

  const handleDecline = () => {
    localStorage.setItem('cookie-consent', 'false');
    setShowBanner(false);
    window.gtag('consent', 'update', {
      'ad_storage': 'denied',
      'analytics_storage': 'denied'
    });
  };

  if (!showBanner) {
    return null;
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-gray-800 text-white p-4 flex justify-between items-center z-50">
      <p className="text-sm">
        We use cookies to enhance your experience. By continuing to visit this site you agree to our use of cookies.
        <Link href="/privacy-policy" className="underline ml-2">
          Learn more
        </Link>
      </p>
      <div>
        <button onClick={handleAccept} className="bg-green-500 hover:bg-green-600 text-white font-bold py-2 px-4 rounded mr-2">
          Accept
        </button>
        <button onClick={handleDecline} className="bg-red-500 hover:bg-red-600 text-white font-bold py-2 px-4 rounded">
          Decline
        </button>
      </div>
    </div>
  );
};

export default CookieBanner;
